import { useWindowSize } from "@components/window-size-provider";
import useHasPermission from "@hooks/useHasPermission";
import { IssueFilters } from "@mwServices/Issue";
import { Button, Col, Drawer, Row } from "antd";
import { ReactElement, useEffect, useState } from "react";
import {isEqual} from "underscore";

export interface IssueFilterDrawerProps {
    filters: IssueFilters;
    setFilters: (filters: IssueFilters) => void;
    renderFooter?: any,
    children?: ReactElement[];
}

export const defaultIssueFilterProps: IssueFilterDrawerProps = {
    filters: {},
    setFilters: (filters: IssueFilters) => { },
}

const RenderFooter = ({ onSearch }) => {
    return (
        <Row justify="center">
            <Col >
                <Button
                    className="outlineButton thickButton width-250px"
                    onClick={() => onSearch()}>SEARCH
                </Button>
            </Col>
        </Row>
    )
}

const IssueFilterDrawer = ({
    title = "Filters & Sorting",
    renderFooter,
    visible,
    onSearch,
    onClose,
    children
}) => {
    const windowDimensions = useWindowSize();
    const [drawerWidth, setDrawerWidth] = useState(450);
    const isAdmin = useHasPermission('admin');

    useEffect(() => {
        const newWidth = (windowDimensions.width < 450) ? windowDimensions.width : 450;
        if (newWidth !== drawerWidth) setDrawerWidth(newWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowDimensions]);

    return (
        <Drawer
            title={title}
            className="issues-filter-drawer"
            headerStyle={{ paddingTop: isAdmin ? 50 : 16 }}
            width={drawerWidth}
            placement="right"
            open={visible}
            onClose={onClose}
            footer={!renderFooter
                ? <RenderFooter onSearch={onSearch} />
                : renderFooter}
        >
            {children}
        </Drawer>
    );
};

IssueFilterDrawer.defaultProps = defaultIssueFilterProps;

export const fixFilterObjectEmptyArrays = (newFilters: any, originalFilters: any, checkProps: string[]) => {
    const fixedFilters = {...newFilters};

    // check for empty arrays and remove them, or put them back to the value in the current filters.
    checkProps.forEach(prop => {
        if(!isEqual(fixedFilters[prop], originalFilters[prop]) && (fixedFilters[prop] && fixedFilters[prop].length === 0)) {
            fixedFilters[prop] = originalFilters[prop];
        }
    });
    return fixedFilters;
}

export default IssueFilterDrawer;